import React, { useState, useEffect } from "react";
import "react-phone-input-2/lib/bootstrap.css";
import PhoneInput from "react-phone-input-2";
import { useTranslation } from "react-i18next";
const FormPhoneInput = ({
  value,
  onChange,
  name = "phone",
  id = "phone",
  label = "Phone",
  placeholder = "Phone",
  inputStyle = { height: "55px", width: "100%" },
  required = true,
  readOnly = false,
}) => {
  const { t } = useTranslation();
  const [internalPhone, setInternalPhone] = useState(value || "");
  const [selectedCountry, setSelectedCountry] = useState(""); // Başlangıçta boş olacak

  // Eğer dışarıdan bir değer geliyorsa, içeriği güncelle
  const phoneValue = value !== undefined ? value : internalPhone;
  const setPhoneValue = onChange !== undefined ? onChange : setInternalPhone;

  useEffect(() => {
    if (value !== undefined) {
      setInternalPhone(value);
    }
  }, [value]);

  const handlePhoneChange = (value, data) => {
    const dialCode = data.dialCode;

    // Eğer numara kısmı silindiyse, sadece ülke kodu sabit kalsın
    if (value.replace(dialCode, "").length === 0) {
      setPhoneValue(dialCode); // Sadece ülke kodunu sabitle
      return;
    }

    // Eğer ülke kodu seçilmediyse, numara kısmını koruyarak sadece ülke kodunu ekleyelim
    if (!value.startsWith(dialCode)) {
      value = dialCode + value.replace(/\D/g, "").replace(dialCode, "");
    }

    const phoneNumberWithoutDialCode = value.replace(dialCode, "");

    if (phoneNumberWithoutDialCode.length > 0) {
      setPhoneValue(dialCode + phoneNumberWithoutDialCode); // Dial kodu korunur, sadece numara değişir
    } else {
      setPhoneValue(dialCode); // Numara boşsa, sadece dialCode sabit kalır
    }

    // Eğer onChange fonksiyonu varsa, bunu çağırıyoruz
    if (onChange) {
      onChange(dialCode + phoneNumberWithoutDialCode); // Güncellenen numarayı gönderiyoruz
    }
  };

  const handleCountryChange = (countryCode) => {
    // Eğer TR dışındaki bir ülke seçildiyse, sadece o ülkenin kodu geçerli olur
    if (countryCode !== "tr") {
      setSelectedCountry(countryCode);
    } else {
      // TR seçildiğinde, TR sabit kalır, kodu değiştirmeyi engelleriz
      setSelectedCountry("tr");
    }
  };

  return (
    <div className="col-lg-12">
      {label && (
        <label htmlFor={id} className="form-label">
          {label}
        </label>
      )}
      <PhoneInput
        country={selectedCountry || undefined} // Eğer selectedCountry boşsa, undefined gönder
        value={phoneValue}
        onChange={handlePhoneChange}
        onCountryChange={handleCountryChange} // Ülke değiştiğinde, yeni ülke kodunu al
        inputProps={{
          name,
          id,
          placeholder: t(placeholder),
          required,
        }}
        inputStyle={inputStyle} // Dışarıdan stil verebilme
        disabled={readOnly}
      />
    </div>
  );
};

export default FormPhoneInput;
